import React from "react";
import { useTranslation } from "react-i18next";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { BillInsuranceRulesFiles } from "./components/BillInsuranceRulesFiles";
import { HouseInsuranceRulesFiles } from "./components/HouseInsuranceRulesFiles";

interface IMaxPlanRulesFilesProps {
  jointBillServicePlanId: PlanId;
}

export const MaxPlanRulesFiles: React.FC<IMaxPlanRulesFilesProps> = (props) => {
  const { jointBillServicePlanId } = props;

  const { t } = useTranslation();

  return (
    <div>
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MCI) && <HouseInsuranceRulesFiles />}
      {jointBillServicePlanId == PlanId.MAX && t("common.and")}
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MBI) && <BillInsuranceRulesFiles />}
    </div>
  );
};
